// extracted by mini-css-extract-plugin
export default {"root":"IconIroningStreamlineTabler_root__nwDgn"};